export enum SourceType {
  Branch = "branch",
  Employee = "employee",
  Warehouse = "warehouse",
}
